import { render, staticRenderFns } from "./inspSales.vue?vue&type=template&id=6a2fccd9"
import script from "./inspSales.vue?vue&type=script&lang=js"
export * from "./inspSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports